export default __webpack_public_path__ + "static/media/sliderFlip_noThemeSelected.71c012cb.svg";